<div class="char-block">
  <div class="char-block__head">
    <h2 class="char-block__head-title">
      {{ "ANALYTICS_PAGE.RETURNS" | translate }}
    </h2>

    <div class="char-block__date-filter">
      <button
        [class.active]="dateFilter === dateState.Week"
        (click)="setTimeFrame(dateState.Week)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.WEEK" | translate }}
      </button>
      <button
        [class.active]="dateFilter === dateState.Month"
        (click)="setTimeFrame(dateState.Month)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.MONTH" | translate }}
      </button>
      <button
        [class.active]="dateFilter === dateState.Year"
        (click)="setTimeFrame(dateState.Year)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.YEAR" | translate }}
      </button>
    </div>
  </div>

  <hr />

  <div
    [class.hidden]="isDataValid"
    class="char-block__empty">
    <h2 class="char-block__empty-title">
      {{ "ANALYTICS_PAGE.EMPTY_DATA" | translate }}
    </h2>

    <p class="char-block__empty-description">
      {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_HEADER" | translate }}
    </p>

    <p class="char-block__empty-description">
      {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_INFO" | translate }}
      <a routerLink="/support"> {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_SUPPROT" | translate }}</a>
      .
    </p>
  </div>

  <div [class.hidden]="!isDataValid">
    <div class="char-block__main">
      <div class="char-block__payment">
        <div class="char-block__payment-item">
          <span class="payment-title">{{ "ANALYTICS_PAGE.TOTAL_RETURNS" | translate }}</span>
          <span class="payment-currency">{{ totalNumberRefounds || 0 }}</span>
        </div>

        <div class="char-block__payment-item">
          <span class="payment-title">{{ "ANALYTICS_PAGE.TOTAL_RETURNS_SUM" | translate }}</span>
          <span class="payment-currency">{{ "₸" + (totalSumRefounds | number: "1.0-0") }}</span>
        </div>
      </div>

      <div class="char-block__filter-1">
        <button
          [class.active]="barStates.has(returnBarState.AllPayments)"
          (click)="setData(returnBarState.AllPayments)"
          class="char-block__filter-item item-1">
          {{ "ANALYTICS_PAGE.ALL_RETURNS" | translate }}
        </button>
      </div>
    </div>

    <div
      class="char-block__canvas"
      style="max-width: calc(100% - 10px); max-height: 215px">
      <canvas id="return-bar"></canvas>
    </div>

    <div class="char-block__filter-2">
      <button
        [class.active]="barStates.has(returnBarState.P2p)"
        (click)="setData(returnBarState.P2p)"
        class="char-block__filter-item item-2">
        {{ "ANALYTICS_PAGE.P2P_OPERATION" | translate }}<span class="percent">{{ percents?.p2pSum }} %</span>
      </button>
      <button
        [class.active]="barStates.has(returnBarState.TransitAccount)"
        (click)="setData(returnBarState.TransitAccount)"
        class="char-block__filter-item item-3">
        {{ "ANALYTICS_PAGE.TRANSITION_OPERATION" | translate }}<span class="percent">{{ percents?.transitionSum }} %</span>
      </button>

      <button
        [class.active]="barStates.has(returnBarState.ExternalSystems)"
        (click)="setData(returnBarState.ExternalSystems)"
        class="char-block__filter-item item-4">
        {{ "ANALYTICS_PAGE.EXTERNAL_OPERATION" | translate }}<span class="percent">{{ percents?.externalSum }} %</span>
      </button>
    </div>
  </div>
</div>
